export const DEFAULT_TICK_PADDING = 20;
export const LABEL_ALIGN_TRANSFORM_Y = -5;
export const SUGGESTED_TICK_COUNT = 3;
